<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <h1>Welcome Home</h1>
          <div class="container-form">
            <!-- Banner -->
            <div class="section">
              <h2>Home Banner</h2>
              <div class="form-label mg-top1">Main Banner</div>
              <input id="mainUpload" type="file" accept="video/*" @change="onAddFile($event, 'main')" hidden>
              <div class="home-vid mg-top1">
                <video ref="video" v-if="mainVideoUrl" :src="mainVideoUrl" controls>
                  <!-- <source :src="mainVideoUrl"> -->
                </video>
                <!-- <div class="mg-top1">
                  <button class="btn-vid mg-right" :disabled="isPlaying" @click="play">Play</button>
                  <button class="btn-vid" :disabled="!isPlaying" @click="stop">Stop</button>
                </div> -->
              </div>
              <button class="btn-upload mg-right mg-top1" @click="chooseFiles('main')">Choose</button>
              <div class="mg-top1">
                <div class="wrapper">
                  <div class="input-data">
                    <input type="text" required v-model="mainTitle">
                    <div class="underline"></div>
                    <label>Main Title</label>
                  </div>
                  <div class="text-area mg-top">
                    <textarea name="" id="" required v-model="mainDesc"></textarea>
                    <div class="underline"></div>
                    <label>Main Description</label>
                  </div>
                </div>
              </div>
              <div class="btn-heading">
                <p class="mg-top" v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                      <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                  </ul>
                </p>

                <div class="mg-top1">
                  <button v-if="mainID" class="hov-del btn-add mg-right" @click="delBanner('main')">
                    Delete Main
                  </button>
                  <button class="btn-add" @click="validationMain(mainID ? 'update' : 'add')">
                    {{mainID? 'Update' : 'Add'}} Main
                  </button>
                </div>
              </div>
            </div>

             <div class="section">
              <h2>Floating Banner</h2>
              <div class="form-label mg-top1">Floating Banner</div>
              <!-- <input type="file" accept="image/*" @change="onAddFile($event, 'floating')"> -->
              <input id="floatingUpload" type="file" accept="image/*" @change="onAddFile($event, 'floating')" hidden>
              <div class="mg-top1">
                <div class="imgUpload" >
                  <img v-if="floatingImageUrl" :src="floatingImageUrl" alt="">
                </div>
                <button class="btn-upload mg-right mg-top1" @click="chooseFiles('floating')">Choose</button>
              </div>
              <div class="mg-top1">
                <div class="wrapper">
                  <div class="input-data">
                    <input type="text" required v-model="floatingUrl">
                    <div class="underline"></div>
                    <label>Url Link</label>
                  </div>
                  <div class="text-area mg-top">
                    <textarea name="" id="" required v-model="floatingDesc"></textarea>
                    <div class="underline"></div>
                    <label>Floating Description</label>
                  </div>
                </div>
              </div>
              <div class="btn-heading">
                <p class="mg-top" v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                      <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                  </ul>
                </p>

                <div class="mg-top1">
                   <button v-if="floatingID" class="hov-del btn-add mg-right" @click="delBanner('floating')">
                    Delete Floating
                  </button>
                  <button class="btn-add" @click="validationFloating(floatingID ? 'update' : 'add')">
                    {{floatingID? 'Update' : 'Add'}} Floating
                  </button>
                </div>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';

import auth from '@/service/auth.js'

export default {
  name: 'Home',
  data() {
    return {
      isLoading: false,
      isPlaying: false,

      mainID: '',
      mainFile: null,
      mainVideoUrl: null,
      mainFileType: '',
      mainTitle: '',
      mainDesc: '',

      floatingID: '',
      floatingFile: null,
      floatingImageUrl: null,
      floatingFileType: '',
      floatingDesc: '',
      floatingUrl: '',

      errors: [],
    }
  },
  methods: {
    validationMain(type) {
      this.errors = []

      if (!this.mainFile) this.errors.push('* Video required')
      
      if (this.errors.length > 0) {
          return
      } else if (type === 'add') {
          this.addBanner('main')
      } else if (type === 'update') {
          this.updateBanner('main')
      }
    },
    validationFloating(type) {
      this.errors = []

      if (!this.floatingFile) this.errors.push('* Image required')
      
      if (this.errors.length > 0) {
          return
      } else if (type === 'add') {
          this.addBanner('floating')
      } else if (type === 'update') {
          this.updateBanner('floating')
      }
    },
    async getBanner (type) {
      this.isLoading = true
      try {
        const response = await axios.get('/content/banner', { params: { type: type }})
        console.log(response)
        this.isLoading = false
        if (type === 'main' && response.data.banner_type === 'main') {
          this.mainID = response.data.banner_id
          this.mainFileType = response.data.asset_type
          this.mainFile = response.data.asset
          this.mainVideoUrl = response.data.asset
          this.mainTitle = response.data.title.String
          this.mainDesc = response.data.description.String
        } else if (type === 'floating' && response.data.banner_type === 'floating') {
          this.floatingID = response.data.banner_id
          this.floatingFileType = response.data.asset_type
          this.floatingFile = response.data.asset
          this.floatingImageUrl = response.data.asset
          this.floatingDesc = response.data.description.String
          this.floatingUrl = response.data.url_link.String
        }
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async addBanner (type) {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        try {
            this.isLoading = true
            const formData = new FormData()
            if (type === 'main') {
              // let type = 'video'
              formData.append('banner_type', 'main')
              formData.append('asset', this.mainFile)
              // formData.append('asset_type ', this.mainFileType)
              formData.append('asset_type', 'video')
              formData.append('title', this.mainTitle)
              formData.append('description', this.mainDesc)
            } else if (type === 'floating') {
              formData.append('banner_type', 'floating')
              formData.append('asset', this.floatingFile)
              formData.append('description', this.floatingDesc)
              // formData.append('asset_type ', this.mainFileType)
              formData.append('asset_type', 'picture')
              formData.append('url_link', this.floatingUrl)
            }
          
            const response = await axios.post('/content/banner', formData)
            this.isLoading = false
  
            console.log(response)
            if(response.status == 201) {
                alert.success('Add data success', () => this.getBanner(type))
            }
  
        } catch (err) {
            console.log(err)
            alert.failed('Add data failed')
        }
      }
    },
    async updateBanner (type) {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        try {
            this.isLoading = true
            const formData = new FormData()
            if (type === 'main') {
              // let type = 'video'
              // formData.append('type', 'main')
              formData.append('asset', this.mainFile)
              // formData.append('asset_type ', this.mainFileType)
              formData.append('asset_type', 'video')
              formData.append('title', this.mainTitle)
              formData.append('description', this.mainDesc)
            } else if (type === 'floating') {
              // formData.append('banner_type', 'floating')
              formData.append('asset', this.floatingFile)
              formData.append('description', this.floatingDesc)
              // formData.append('asset_type ', this.mainFileType)
              formData.append('asset_type', 'picture')
              formData.append('url_link', this.floatingUrl)
            }
          
            const response = await axios.patch(`/content/banner/${type}`, formData)
            this.isLoading = false
  
            console.log(response)
            if(response.status == 200) {
                alert.success('Update data success', () => this.getBanner(type))
            }
  
        } catch (err) {
            console.log(err)
            alert.failed('Update data failed')
        }
      }
    },
    async delBanner (type) {
      console.log(type)
      let self = this
      alert.confirmation( async function () {
        self.isLoading = true
        try {
          const response = await axios.delete(`/content/banner/${type}`)
          self.isLoading = false
          console.log(response)
          // self.getBanner(type)
          alert.success('Delete data success', () => self.getBanner(type))
        } catch (error) {
          self.isLoading = false
          console.log(error)
          alert.failed('Delete data failed')
        }
      }, 'Are you sure to delete it?')
    },
    onAddFile (e, type) {
      console.log('file', e)
      if (type === 'main') {
        this.mainFile = e.target.files[0]
        this.mainVideoUrl = URL.createObjectURL(this.mainFile)
        // if (e.target.files[0].type.includes('image')) {
        //   this.mainFileType = 'picture'
        // }
      } else if (type === 'floating') {
        this.floatingFile = e.target.files[0]
        this.floatingImageUrl = URL.createObjectURL(this.floatingFile);
      }
    },
    chooseFiles(type) {
      if (type === 'main') {
        document.getElementById("mainUpload").click()
      } else if (type === 'floating') {
        document.getElementById("floatingUpload").click()
      }
    },
    // play() {
    // 	this.$refs.video.play()
    //   this.isPlaying = true
    // },
    // stop() {
    // 	this.$refs.video.pause()
    //   this.isPlaying = false
    // }
  },
  components: {
    Loader
  },
  async created () {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
    this.getBanner('main')
    this.getBanner('floating')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
